import type { ReactNode } from "react";

import { Box } from "../../primitives";

/**
 * Web inner content — height animation handled by CSS keyframes on the parent.
 * It sets no text style: string content gets its Typography from
 * AccordionContent, and composed content keeps the page's.
 */
export const AccordionContentInner = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => <Box className={className}>{children}</Box>;
